/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useState, useEffect } from "react";
import { GetBatches } from "../../services/BatchService";
import MicroOutForm from "./MicroOutForm";
import { appInsights } from "../../services/appInisights";
import { NotificationManager } from "react-notifications";
import { BatchName } from "../../services/dateService";
import CommonLoader from '../../vlp/components/common/CommonLoader';

export default function MicroOut({ location, user }) {
	const [selectedBatch, setSelectedBatch] = useState({});
	const [batches, setBatches] = useState([]);
	const [loading, setLoading] = useState(false);
	const updateBatches = (childData) => {
		let index = batches.findIndex((batch) => batch.id === childData.id);
		if (index >= 0) {
			batches.splice(index, 1);
			const updatedBatches = [...batches];
			updatedBatches.push(childData);
			setBatches(updatedBatches)
		}
	}
	useEffect(() => {
		loadBatches();
	}, [location]);
	
	async function loadBatches() {
		setLoading(true);
		try {
			let b = await GetBatches();
			if (b) {
				let filtered = b.filter((item) => item.location === location);
				setBatches(filtered);
				if (filtered.length > 0) {
					setSelectedBatch(filtered[0])
				}
				else{
					setSelectedBatch([])
				}
			}
			else {
				NotificationManager.info("No pending batches found");
			}
		} catch (err) {
			appInsights.trackException({
				error: err,
				properties: { message: "Failed to get batches from API" },
			});
			NotificationManager.error("Unable to get batches", "Error");
		}
		finally {
			setLoading(false);
		  }
	}

	useEffect(() => {		
		if (selectedBatch.outUser !== user)
			setSelectedBatch({ ...selectedBatch, outUser: user });
	}, [selectedBatch, setSelectedBatch, user]);

	const getBatchCount = (batchType) => {
		let leng = batches.filter((i) => i.analysisType === batchType).length;
		return <span style={{ color: '#3488CE', fontWeight: 'bold' }} >({leng})</span>
	};

	const dateToString = (input) => {
		return BatchName(input);
	};

	const handleSubmissionSuccess = () => {
		// setBatches(batches.filter((i) => i.id !== batch.id));
		setSelectedBatch({});
		loadBatches();
	};

	/**
	 * Uses the provided item's color to determine how long it has been since the sample was submitted
	 * @param {object} item Item to determine the range of time passed since the sample was submitted 
	 */
	const determineTimeRange = (item) => {
		// Precautionary checks
		if (!item) return;
		if (!item.analysisType || !item.color) return;

		const analysisType = item.analysisType;
		const color = item.color;

		const computeTimeRange = (lowerBound, upperBound) => {
			switch (color) {
				case 'Grey':
					return `<= ${lowerBound} hours`;
				case 'Green':
					return `${lowerBound}-${upperBound} hours`;
				case 'Red':
					return `>= ${upperBound} hours`;
				default:
					return 'Error';
			}
		};

		switch (true) {
			// Check if analysis type starts with TC
			case /HPC/.test(analysisType):
				// Check if analysis type is HPCDW
				if (/HPCDW/.test(analysisType)) {
					return computeTimeRange(48, 72); // HPCDW==>TimeRange(48, 72)
				} else {
					return computeTimeRange(45, 72); // HPC==>TimeRange(45, 72)
				}
			// Check if analysis type is ecoli
			case /Ecoli/.test(analysisType):
				return computeTimeRange(24, 28);
			// Check if analysis type starts with HPC
			case /^TC/.test(analysisType):
				return computeTimeRange(24, 28);
			default:
				return 'Error';
		}
	};


	return (
		<>
			<hr />
			<div className="columns">
				<div className="column is-3">
					<table className="table is-striped is-fullwidth">
						<thead>
							<tr>
								<td className="is-bold">HPC (DW) Batches -{getBatchCount("HPCDW")} </td>
								<td></td>
							</tr>
						</thead>
						<tbody>
							{batches
								.filter((i) => i.analysisType === "HPCDW")
								.map((item) => (
									<tr
										key={item.id}
										id={item.id}
										className={selectedBatch === item ? "is-selected" : ""}
									>
										<td>
											<a
												href="#"
												style={{ color: item.color }}
												onClick={() => {
													setSelectedBatch(item);
												}}
											>
												{`${dateToString(item.inTime)} (${determineTimeRange(item)})`}
											</a>
										</td>
									</tr>
								))}
						</tbody>
					</table>
					<table className="table is-striped is-fullwidth">
						<thead>
							<tr>
								<td className="is-bold">HPC (Pool) Batches -{getBatchCount("HPC")} </td>
								<td></td>
							</tr>
						</thead>
						<tbody>
							{batches
								.filter((i) => i.analysisType === "HPC")
								.map((item) => (
									<tr
										key={item.id}
										id={item.id}
										className={selectedBatch === item ? "is-selected" : ""}
									>
										<td>
											<a
												href="#"
												style={{ color: item.color }}
												onClick={() => {
													setSelectedBatch(item);
												}}
											>
												{`${dateToString(item.inTime)} (${determineTimeRange(item)})`}
											</a>
										</td>
									</tr>
								))}
						</tbody>
					</table>
					<table className="table is-striped is-fullwidth">
						<thead>
							<tr>
								<td className="is-bold">TC (DW) Batches -{getBatchCount("TCDW")}</td>
								<td></td>
							</tr>
						</thead>
						<tbody>
							{batches
								.filter((i) => i.analysisType === "TCDW")
								.map((item) => (
									<tr
										key={item.id}
										id={item.id}
										className={selectedBatch === item ? "is-selected" : ""}
									>
										<td>
											<a
												style={{ color: item.color }}
												onClick={() => setSelectedBatch(item)}
											>
												{`${dateToString(item.inTime)} (${determineTimeRange(item)})`}
											</a>
										</td>
									</tr>
								))}
						</tbody>
					</table>
					<table className="table is-striped is-fullwidth">
						<thead>
							<tr>
								<td className="is-bold">TC (Pool) Batches -{getBatchCount("TCPOOL")}</td>
								<td></td>
							</tr>
						</thead>
						<tbody>
							{batches
								.filter((i) => i.analysisType === "TCPOOL")
								.map((item) => (
									<tr
										key={item.id}
										id={item.id}
										className={selectedBatch === item ? "is-selected" : ""}
									>
										<td>
											<a
												style={{ color: item.color }}
												onClick={() => setSelectedBatch(item)}
											>
												{`${dateToString(item.inTime)} (${determineTimeRange(item)})`}
											</a>
										</td>
									</tr>
								))}
						</tbody>
					</table>
					<table className="table is-striped is-fullwidth">
						<thead>
							<tr>
								<td className="is-bold">EC Batches -{getBatchCount("Ecoli")}</td>
								<td></td>
							</tr>
						</thead>
						<tbody>
							{batches
								.filter((i) => i.analysisType === "Ecoli")
								.map((item) => (
									<tr
										key={item.id}
										id={item.id}
										className={selectedBatch === item ? "is-selected" : ""}
									>
										<td>
											<a
												style={{ color: item.color }}
												onClick={() => setSelectedBatch(item)}
											>
												{`${dateToString(item.inTime)} (${determineTimeRange(item)})`}
											</a>
										</td>
									</tr>
								))}
						</tbody>
					</table>
				</div>
				<div className="column">
					{selectedBatch && (
						<MicroOutForm
							model={selectedBatch}
							onSuccess={handleSubmissionSuccess}
							callBack={updateBatches}
						/>
					)}
				</div>
			</div>
			<CommonLoader loading={loading} />
		</>
	);
}
